<template>
  <el-input type="text"
            v-model="bindValue"
            :placeholder="placeholder"
            :maxlength="maxLength"
            :rows="rows"
            :type="type"
            :size="size"
            :disabled="disabled"
            :show-word-limit="showWordLimit"
            @blur="blur"
            :clearable="clearable"
  >
    <template v-slot:suffix>
      <slot name="suffix">
      </slot>
    </template>
  </el-input>
</template>

<script>
export default {
  name: 'DyInput',
  props: {
    value: {
      type: [String, Number, null, undefined],
      default: ''
    },
    placeholder: {
      type: String,
    },
    allowSpecialChar: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    decimalLength: {
      type: Number,
      default: 10,
    },
    showWordLimit: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: String,
    },
    type: {
      type: String,
    },
    size: {
      type: String,
    },
    // text, integer 整数, positive-integer, negative-integer, non-negative-integer, non-positive-integer, float, non-negative-float, non-positive-float
    valueType: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: [Number, String]
    }
  },
  computed: {
    bindValue: {
      get() {
        return this.value
      },
      set(val) {
        let returnVal = val && val.trim();
        switch (this.valueType) {
          case "integer": {
            returnVal = returnVal
                .replace(/[^-\d+]/g, "")
                .replace(/(\d+)-*/g, "$1")
                .replace(/(-)-+/, "$1");
            break;
          }
          case "non-negative-integer": {
            returnVal = returnVal.replace(/[^\d]/g, "");
            break;
          }
          case "non-negative-float": {
            returnVal = returnVal.replace(/[^\d|.]/g, "");
            let arr = returnVal.split(".");
            if (arr.length > 1) {
              returnVal = `${Number.parseFloat(arr[0] ? arr[0] : 0)}.${
                  arr[1] ? arr[1] : ""
              }`;
            } else {
              const defaultVal = this.required ? "0" : "";
              const parseNum = Number.parseFloat(arr[0]);
              if (!isNaN(parseNum)) {
                returnVal = parseNum;
              } else {
                returnVal = defaultVal;
              }
            }
            break;
          }
          case "text": {
            if (this.allowSpecialChar) {
              returnVal = val;
            } else {
              returnVal = returnVal.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, "");
            }
            break;
          }
          default:
            break;
        }
        this.$emit("input", returnVal);
      }
    }
  },
  methods: {
    blur() {
      if (this.isInteger && this.value?.length > 0 && this.required) {
        this.$emit("input", Number.parseFloat(this.value));
      }
      this.$emit("focusout");
    },
  },
};
</script>

<style scoped>

</style>
